import { Dialog, useDialogState } from 'ariakit/dialog';
import type { ReactNode } from 'react';
import { forwardRef, useImperativeHandle } from 'react';
import styled, { css } from 'styled-components';

export interface IModalProps {
  children: ReactNode;
  onCancel?: () => void;
  titleId?: string;
  hideOnEscape?: boolean;
}

export interface IModalRef {
  showModal: () => void;
  hideModal: () => void;
}

const Modal = forwardRef(
  ({ onCancel, titleId, children, hideOnEscape = true }: IModalProps, ref) => {
    const dialog = useDialogState();

    useImperativeHandle(ref, () => {
      return {
        showModal: () => {
          dialog.show();
        },
        hideModal: () => {
          onCancel && onCancel();
          dialog.hide();
        },
      };
    }, [dialog, onCancel]);
    return (
      <StyledDialog
        state={dialog}
        tabIndex={0}
        hideOnEscape={hideOnEscape}
        aria-modal="true"
        aria-labelledby={titleId ?? undefined}
      >
        {children}
      </StyledDialog>
    );
  }
);

Modal.displayName = 'Modal';

export default Modal;

const StyledDialog = styled(Dialog)`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 6000;
    background: ${theme.palette.black(0.5)};
    display: flex;
    justify-content: center;
    align-items: center;
  `}
`;
